module.exports = __webpack_public_path__ + "img/solid-background-map-hours-light.35bf009c.png";